import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown } from 'semantic-ui-react';
import MenuUtil from './utils/menu';
import './FoodMenuCategoryNavigation.css';

export default class MenuCategoryNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: 0,
      selectedCategory: null,
    };

    this.getScheduleCategories = this.getScheduleCategories.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.getDropdownOptions = this.getDropdownOptions.bind(this);
    this.onSelectCategory = this.onSelectCategory.bind(this);
    this.smoothScroll = this.smoothScroll.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    const { parentId, disabledAutoScrollDetection } = this.props;

    if (typeof document !== `undefined` && !disabledAutoScrollDetection) {
      const container = document.getElementById(parentId);
      container.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    const { parentId, disabledAutoScrollDetection } = this.props;

    if (typeof document !== `undefined` && !disabledAutoScrollDetection) {
      const container = document.getElementById(parentId);
      container.removeEventListener('scroll', this.onScroll);
    }
  }

  getScheduleCategories() {
    const { scheduleId, schedules, categories } = this.props;
    const schedule = MenuUtil.getScheduleById(schedules, scheduleId);
    const { categories: scheduleCategoryIds } = schedule;
    return MenuUtil.getScheduleCategories(scheduleCategoryIds, categories);
  }

  onItemClick(e) {
    this.smoothScroll(e);
  }

  getDropdownOptions() {
    return this.getScheduleCategories().map(({ name }) => ({
      key: name,
      value: name,
      text: name,
      as: 'a',
      href: `#${name}`,
    }));
  }

  smoothScroll(e) {
    e.preventDefault();

    if (typeof document !== `undefined`) {
      const { scrollOffset, parentId } = this.props;
      const id = e.currentTarget.getAttribute('href').slice(1);
      const anchor = document.getElementById(id);
      const container = document.getElementById(parentId);
      container.scroll({
        top: anchor.offsetTop - scrollOffset,
        behavior: 'smooth',
      });
    }
  }

  onScroll() {
    const { parentId, autoScrollOffset, getMenuCategoryElements } = this.props;
    const { activeItem } = this.state;

    if (typeof document !== `undefined`) {
      const container = document.getElementById(parentId);
      const menuContainer = getMenuCategoryElements(document.getElementById(parentId));
      const scrollPos = menuContainer.scrollTop;

      [...menuContainer.children].forEach((child, index) => {
        if (
          index > 0 &&
          child.offsetTop + autoScrollOffset < container.scrollTop &&
          child.offsetTop + child.offsetHeight + autoScrollOffset > container.scrollTop
        ) {
          if (index - 1 !== activeItem) {
            this.setState({
              activeItem: index - 1,
              selectedCategory: this.getDropdownOptions()[index - 1].value,
            });
          }
        }
      });
    }
  }

  onSelectCategory(e, { value }) {
    this.setState({ selectedCategory: value });
  }

  render() {
    const { activeItem, selectedCategory } = this.state;

    return (
      <div className="food-menu-category-navigation">
        <Menu pointing secondary className="desktop">
          {this.getScheduleCategories().map(({ name }, index) => (
            <Menu.Item
              key={name}
              name={name}
              active={index === activeItem || name === activeItem}
              onClick={this.onItemClick}
              href={`#${name}`}
            >
              <h4>{name}</h4>
            </Menu.Item>
          ))}
        </Menu>
        <div className="mobile">
          <Dropdown
            onChange={this.onSelectCategory}
            placeholder="Categories"
            fluid
            selection
            value={selectedCategory}
            options={this.getDropdownOptions()}
          />
        </div>
      </div>
    );
  }
}

MenuCategoryNavigation.propTypes = {
  scheduleId: PropTypes.number.isRequired,
  schedules: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  parentId: PropTypes.string.isRequired,
  getMenuCategoryElements: PropTypes.func.isRequired,
  disabledAutoScrollDetection: PropTypes.bool,
  scrollOffset: PropTypes.number,
  autoScrollOffset: PropTypes.number,
};

MenuCategoryNavigation.defaultProps = {
  disabledAutoScrollDetection: false,
  scrollOffset: -160,
  autoScrollOffset: 150,
};
